import React from 'react';
import { ToggleButton } from '../../../ToggleButton';
import { LockUnlocked, LockLocked } from '@wix/wix-ui-icons-common';
import { CornerRadiusInputProps } from '../../CornerRadiusInput.types';
import { dataHooks } from '../../CornerRadiusInput.constants';
import { useIcons } from '../../../WixDesignSystemIconThemeProvider';

type LinkingButtonProps = {
  size: CornerRadiusInputProps['size'];
  isLinkingEnabled: boolean;
  setLinking: React.Dispatch<React.SetStateAction<boolean>>;
  linkingButtonLabels: CornerRadiusInputProps['linkingButtonLabels'];
  onLinkedToggle?: CornerRadiusInputProps['onLinkedToggle'];
};

const LinkingButton = ({
  size,
  isLinkingEnabled,
  setLinking,
  linkingButtonLabels,
  onLinkedToggle,
}: LinkingButtonProps) => {
  const icons = useIcons('CornerRadiusInputLinkingButton', {
    LockUnlocked,
    LockLocked,
  });

  return (
    <ToggleButton
      size={size}
      dataHook={dataHooks.autoScaleButton}
      border
      selected={isLinkingEnabled}
      labelValue={
        isLinkingEnabled
          ? linkingButtonLabels?.pressed
          : linkingButtonLabels?.unpressed
      }
      labelPlacement="tooltip"
      onClick={() => {
        setLinking(prev => !prev);
        onLinkedToggle?.(!isLinkingEnabled);
      }}
      tooltipProps={{
        textAlign: 'center',
      }}
    >
      {isLinkingEnabled ? <icons.LockLocked /> : <icons.LockUnlocked />}
    </ToggleButton>
  );
};

export { LinkingButton };
